var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('s-button',{attrs:{"icon":"file-pdf","disabled":_vm.pdfLoading,"is-loading":_vm.pdfLoading},on:{"click":_vm.showPdf}},[_vm._t("default",[_vm._v(_vm._s(_vm.$t('Invoice.showPDF')))])],2)}
var staticRenderFns = []

export { render, staticRenderFns }